<template>
	<button
		class="text-button"
		@click.prevent="handleClick"
		:aria-label="ariaLabel"
		:disabled="disabled"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'TextButton',
	props: {
		ariaLabel: {
			type: String,
			default: 'Text Button',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleClick(event) {
			this.$emit('onClick', event);
		},
	},
};
</script>

<style lang="scss" scoped>
.text-button {
	color: $brand-blue;
	font-weight: 500;
	border: none;
	background: none;
	padding: 0;
	text-align: left;
	@include rem('font-size', 16px);

	&:hover,
	&:focus,
	&:active,
	&.active {
		color: $b360-color--blue__darker;
		cursor: pointer;
	}
	&:disabled {
		color: $b360-color--gray__medium-plus;
		cursor: not-allowed;
	}
}
</style>
